exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.go_bind:before {\n    border-color: #1a96d4 !important;\n    border-radius: 6px !important;\n}\n", ""]);

// exports
